var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoTous1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32,15c9.37,0,17,7.63,17,17s-7.63,17-17,17-17-7.63-17-17,7.63-17,17-17m0-6c-12.7,0-23,10.3-23,23s10.3,23,23,23,23-10.3,23-23-10.3-23-23-23h0Zm26,10.15V6h-13.15c5.7,2.82,10.33,7.46,13.15,13.15ZM19.15,6H6v13.15c2.82-5.7,7.46-10.33,13.15-13.15Zm25.69,52h13.15v-13.15c-2.82,5.7-7.46,10.33-13.15,13.15ZM6,44.85v13.15h13.15c-5.7-2.82-10.33-7.46-13.15-13.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoTous1);
export default __webpack_public_path__ + "static/media/picto-tous1.3dde38134193b52f7f106d5a22e528f2.svg";
export { ForwardRef as ReactComponent };